import type { ExecutionAcceptedFormat, ScheduleEntityConfig } from "../model/types";

export const EXECUTION_ACCEPTED_FORMAT: ExecutionAcceptedFormat = {
  description: ".ifc",
  extensions: [".ifc"],
  maxSizeMB: undefined,
};

export const EXECUTION_ALTORITHM = {
  PRE_RAYTRACING: {
    name: "Pre-raytracing",
  },
  RAYTRACING: {
    name: "raytracing",
  },
};

export const EXECUTION_MESHING_METHODS = ["Automatic", "Amount"];

export const DEFAULT_MESHING_METHOD = "";

export const EXECUTION_POLL_INTERVAL_MS = 7500;

export const SCHEDULE_ENTITY_CONFIG: ScheduleEntityConfig[] = [
  { entity: "walls", insertedKey: "walls_inserted", phase: "posting_walls", totalKey: "walls_total" },
  { entity: "windows", insertedKey: "windows_inserted", phase: "posting_windows", totalKey: "windows_total" },
  { entity: "rooms", insertedKey: "rooms_inserted", phase: "posting_rooms", totalKey: "rooms_total" },
  { entity: "pv_panels", insertedKey: "pv_panels_inserted", phase: "posting_pv_panels", totalKey: "pv_panels_total" },
];

export const ALTERNAIVE_VALUE_FOR_NULL_INSERTIONS = 0;

export const IS_RT_CONFIG_ENABLED = false;
